import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ExpenseAddLayer from "../components/ExpenseAddLayer";




const ExpenseAddPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* ExpenseAddLayer */}
        <ExpenseAddLayer />

      </MasterLayout>

    </>
  );
};

export default ExpenseAddPage;
